import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [//路由配置
    {
      path     : '/',
	    component: () => import('../views/Page/Page.vue'),
    },
    {
      path     : '/Phone',
	    component: () => import('../views/Phone/Phone.vue'),
    }
]

const router = new VueRouter({
  // 路由模式
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 重复点击路由报错解决
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default router
